var render = function render(){var _vm=this,_c=_vm._self._c;return _c('em-z-tree',{ref:"locationTree",attrs:{"treeNodes":_vm.locationTreeNodes,"chkboxType":_vm.chkboxType,"textKeys":"name","checkEnable":"","multiSelect":_vm.enableMulti}})
}
var staticRenderFns = []

export { render, staticRenderFns }